export default __webpack_public_path__ + "static/media/5.f2ed3196.jpg";